import { createSlice } from "@reduxjs/toolkit";

const quoteEntrySlice = createSlice({
  name: "quoteEntry",
  initialState: {
    quotes: [],
    detailsByQuoteId: {},
  },
  reducers: {
    setQuotes: (state, action) => {
      state.quotes = action.payload;
    },
    setQuoteDetails: (state, action) => {
      const { quoteId, details } = action.payload;
      state.detailsByQuoteId[quoteId] = details;
    },
    // updateQuoteDetail: (state, action) => {
    //   const { quoteId, detailId, newData } = action.payload;

    //   const quoteDetails = state.detailsByQuoteId[quoteId];
    //   if (!quoteDetails) return;

    //   const index = quoteDetails.findIndex((d) => d.id === detailId);
    //   if (index === -1) return;

    //   quoteDetails[index] = {
    //     ...quoteDetails[index],
    //     ...newData
    //   };
    // },
    updateQuoteDetail: (state, action) => {
      const { quoteId, detailId, newData } = action.payload;

      if (!state.detailsByQuoteId[quoteId]) {
        state.detailsByQuoteId[quoteId] = [];
      }

      const details = state.detailsByQuoteId[quoteId];
      const idx = details.findIndex((d) => d.id === detailId);

      if (idx !== -1) {
        // update existente
        details[idx] = { ...details[idx], ...newData };
      } else {
        // insert nuevo
        details.push(newData);
      }
    },
    removeQuoteDetails: (state, action) => {
      const quoteIds = action.payload; // puede ser un solo id o array
      quoteIds.forEach((id) => {
        delete state.detailsByQuoteId[id];
      });
    },

    resetQuoteDetails: (state) => {
      state.detailsByQuoteId = {};
    },
  },
});

export const {
  setQuotes,
  setQuoteDetails,
  updateQuoteDetail,
  resetQuoteDetails,
  removeQuoteDetails
} = quoteEntrySlice.actions;
export default quoteEntrySlice.reducer;
